import { useEffect, useState } from 'react';

// Coalesce a rapid typist's keystrokes before firing a request. Promoted from
// src/modules/metaAds (2026-09-30) when the publishing link-card preview needed
// the same thing — metaAds re-exports it, so its call sites are unchanged.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
